import styled from 'styled-components'

const ProjectsPlaceholderStyled = styled.div`
  margin-top: 24px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(288px, 1fr));
  column-gap: 24px;
  row-gap: 24px;
  @media(min-width: 1366px) {
    grid-template-columns: repeat(auto-fill, minmax(310px, 1fr));
  }
`

const ProjectCardPlaceholder = styled.div`
  padding: 16px;
  background: var(--basePrimary);
  border-radius: 4px;
  &:nth-of-type(2),
  &:nth-of-type(3) {
    display: none;
  }
  .img-placeholder {
    background: var(--neutral70);
    padding-top: 74.99%;
  }
  .tag-placeholder {
    background: var(--baseSecondary);
    max-inline-size: 77px;
    block-size: 32px;
    border-radius: 72px;
    margin: 16px 0;
  }
  .title-placeholder {
    block-size: 32px;
    background: var(--neutral80);
    max-inline-size: 65%;
  }
  .description-placeholder {
    background: var(--neutral70);
    block-size: 16px;
    margin-block-start: 8px;
    &:nth-of-type(3) {
      max-inline-size: 90%;
    }
    &:nth-of-type(4) {
      max-inline-size: 30%;
    }
  }
  .btn-placeholder {
    block-size: 48px;
    border-radius: 4px;
    background: var(--secondary);
    margin-block-start: 16px;
  }
  .skeleton {
    background-image: linear-gradient(90deg, var(--neutral70), #ffffff2b, var(--neutral70));
    background-size: 50px 100%;
    background-repeat: no-repeat;
    background-position: left -40px top 0;
    animation: shine 1s ease infinite;
    &:nth-of-type(1) {
      animation-duration: 0.8s;
    }
    &:nth-of-type(2) {
      animation-delay: 0.1s;
    }
    &:nth-of-type(3) {
      animation-delay: 0.2s;
    }
    &:nth-of-type(4) {
      animation-delay: 0.3s;
      animation-duration: 0.8s;
    }
  }
  @keyframes shine {
    to {
      background-position: right -40px top 0;
    }
  }

  @media(min-width: 768px) {
    &:nth-of-type(2) {
      display: block;
    }
  }
  @media(min-width: 1024px) {
    &:nth-of-type(3) {
      display: block;
    }
  }
`

function ProjectsPlaceholder() {
  return (
    <ProjectsPlaceholderStyled>
      {[1, 2, 3].map(() => (
        <ProjectCardPlaceholder>
          <div className="img-placeholder skeleton" />
          <div className="tag-placeholder" />
          <div className="title-placeholder" />
          <div>
            <div className="description-placeholder skeleton" />
            <div className="description-placeholder skeleton" />
            <div className="description-placeholder skeleton" />
            <div className="description-placeholder skeleton" />
          </div>
          <div className="btn-placeholder" />
        </ProjectCardPlaceholder>
      ))}
    </ProjectsPlaceholderStyled>
  )
}

export default ProjectsPlaceholder
